/* INT 2026-11-02 OWN WISHLIST (task wishlist-own-or-swym, step 1). Intention's own wishlist drawer and page.
   No Swym. The list comes from window.__intWl (assets/int-header-wishlist.js). Each saved piece is drawn by the
   store itself: /<locale root>products/<handle>?variant=<id>&view=wlitem (templates/product.wlitem.liquid), so
   words, prices and currency are the shopper's. Styles: assets/int-wl.css, loaded on first open.
   The band (Word of the Month, the quiz Word or the quiz button, the set offer) is the same code as the Swym
   era enrichment, unchanged: WORD_MAP, readWom, openQuiz, renderBand.
   Words come from window.__intWishlistI18n (snippets/int-wishlist-modal.liquid), chosen in Liquid per language.
   Wishlist page: templates/page.wishlist.liquid ([data-int-wl-page]); ?items=<handle>:<variant>,... shows a
   shared list, read only. */
(function () {
  if (window.__intWishlistEnrich) return;
  window.__intWishlistEnrich = true;

  var WL_I18N = window.__intWishlistI18n || { dialog: '', close: '' };
  var I = WL_I18N;

  var WORD_MAP = {
    'Balance':'/collections/balance','Synergy':'/collections/synergy','Strength':'/collections/strength',
    'Grateful':'/collections/grateful','Harmonious':'/collections/harmonious','Gratitude':'/collections/gratitude',
    'Faith':'/collections/faith','Abundance':'/collections/abundance','Truthful':'/collections/truthful',
    'Glorious':'/collections/glorious','Real':'/collections/real','Lucky':'/collections/lucky-1',
    'Curiosity':'/collections/curiosity','Love':'/collections/love',
    'Respect':'/collections/respect','Oneness':'/collections/oneness','Jazzy':'/collections/jazzy-1',
    'Fearless':'/collections/fearless','Adventurous':'/collections/adventurous','Transcendence':'/collections/transcendence',
    'Vibrant':'/collections/vibrant','Serenity':'/collections/serenity-1','Energy':'/collections/energy',
    'Resilience':'/collections/resilience','Hopeful':'/collections/hopeful','Freedom':'/collections/freedom-1',
    'Patience':'/collections/patience','Fortitude':'/collections/fortitude','Empowering':'/collections/empowering',
    'Joy':'/collections/joy','Alive':'/collections/alive-1','Sharing':'/collections/sharing-1',
    'Calm':'/collections/calm','Compassion':'/collections/compassion'
  };

  var LOGO = 'https://cdn.shopify.com/s/files/1/0924/7185/3320/files/Intention_logo_medium_CARBON.png?v=1764673472';

  function savedWords() {
    try { var a = JSON.parse(localStorage.getItem('int_quiz_words') || '[]'); return Array.isArray(a) ? a.slice(0, 3) : []; }
    catch (e) { return []; }
  }
  /* INT 2026-09-24: links carry the locale root (TRANSLATION-RULES gate 7), /da/collections/... on Danish. */
  /* 2026-10-07: routes.root_url is "/da" with NO trailing slash, so links came out as /dacollections/calm on da/de.
     Always end the root with one slash. */
  var ROOT = String(WL_I18N.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  function wordLink(w) { return ROOT + (WORD_MAP[w] || ('/collections/' + String(w).toLowerCase())).replace(/^\//, ''); }

  function readWom() {
    var elx = document.querySelector('.drawer__wom:not(.drawer__pam)');
    if (!elx) return null;
    var wordEl = elx.querySelector('.drawer__wom__word');
    var word = wordEl ? (wordEl.textContent || '').trim() : '';
    if (!word) return null;
    var href = (elx.getAttribute('href') || '').trim();
    return { word: word, href: href || wordLink(word) };
  }

  /* ── quiz opener. INT 2026-10-06: the Find your Word quiz lives on /pages/your-word-of-intention
     (sections/int-quiz.liquid) and writes int_quiz_words itself, so the button goes there. ── */
  function openQuiz(e) {
    /* 2026-10-06: opens the quiz in place (snippets/int-quiz-open-boot.liquid); the page is the fallback */
    if (typeof window.intentionOpenQuiz === 'function') { window.intentionOpenQuiz(e && e.currentTarget); return; }
    window.location.href = ROOT + 'pages/your-word-of-intention';
  }

  /* ── builders ── */
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function buildTop(detail) {
    if (detail.querySelector(':scope > .int-wl-top')) return;
    var top = el('div', 'int-wl-top');
    var logo = el('a', 'int-wl-logo'); logo.href = ROOT;
    var img = document.createElement('img'); img.src = LOGO; img.alt = 'Intention'; img.width = 140; img.height = 64;
    logo.appendChild(img); top.appendChild(logo);
    detail.insertBefore(top, detail.firstChild);
  }

  function buildBand(detail) {
    var header = detail.querySelector(':scope > .swym-wishlist-detail-header');
    var sep = detail.querySelector(':scope > .swym-wishlist-detail-separator');
    var band = detail.querySelector(':scope > .int-wl-band');
    if (!band) {
      band = el('div', 'int-wl-band');
      if (header && header.nextSibling) detail.insertBefore(band, header.nextSibling);
      else if (sep) detail.insertBefore(band, sep);
      else detail.appendChild(band);
    }
    var sig = JSON.stringify(savedWords());
    if (band.getAttribute('data-int-sig') === sig) return; /* no change → no re-render (prevents observer loop) */
    band.setAttribute('data-int-sig', sig);
    renderBand(band);
  }

  function renderBand(band) {
    var words = savedWords();
    band.innerHTML = '';
    /* Word of the Month — between the title and the prompt, read live each render */
    var wom = readWom();
    if (wom) {
      var chip = el('a', 'int-wl-wom'); chip.href = wom.href;
      chip.appendChild(el('span', 'int-wl-wom__label', (WL_I18N.wom || 'Word of the Month')));
      chip.appendChild(el('span', 'int-wl-wom__word', wom.word));
      band.appendChild(chip);
    }
    var top = el('div', 'int-wl-band__top');
    if (words.length) {
      /* ONE Word since 2026-10-07 (Nils: "we are focusing on one word now, never 3"): words[0] is the
         quiz result; the other entries the quiz still stores are data only and never shown. */
      top.appendChild(el('p', 'int-wl-kicker', (WL_I18N.kicker || 'Your Word of Intention')));
      var primary = el('a', 'int-wl-word int-wl-word--primary', words[0]);
      primary.href = wordLink(words[0]); top.appendChild(primary);
    } else {
      top.appendChild(el('p', 'int-wl-prompt', (WL_I18N.prompt || 'Discover your Word with a short quiz, and share it.')));
    }
    band.appendChild(top);
    var bundle = el('div', 'int-wl-bundle');
    var btn = el('button', 'int-wl-quiz-btn', (WL_I18N.btn || 'Find my Word →'));
    btn.type = 'button'; btn.addEventListener('click', openQuiz);
    bundle.appendChild(btn);
    var offer = el('p', 'int-wl-bundle__offer');
    offer.appendChild(el('span', 'int-wl-bundle__lead', (WL_I18N.lead || 'Build your set:')));
    offer.appendChild(document.createTextNode(' '));
    /* INT 2026-09-24: one line per tier, broken after the first sentence, in every language. */
    var terms = (WL_I18N.terms || '2 pieces, 15% off. 3 pieces or more, 25% off.').split(/\.\s+/);
    var tb = el('span', 'int-wl-bundle__terms');
    for (var ti = 0; ti < terms.length; ti++) { var tt = terms[ti].replace(/\.$/, ''); if (tt) tb.appendChild(el('span', 'int-wl-bundle__tier', tt + '.')); }
    offer.appendChild(tb);
    bundle.appendChild(offer);
    band.appendChild(bundle);
  }


  /* ── styles on demand ── */
  var cssP = null;
  function css() {
    if (cssP) return cssP;
    cssP = new Promise(function (res) {
      if (document.querySelector('link[data-int-wl-css]') || !I.css) { res(); return; }
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = I.css; l.setAttribute('data-int-wl-css', '');
      l.onload = l.onerror = function () { res(); };
      document.head.appendChild(l);
      setTimeout(res, 3000);
    });
    return cssP;
  }

  /* ── one saved piece, drawn by the store ── */
  var memo = {};
  function itemHtml(it) {
    var k = it.h + ':' + it.v;
    if (memo[k]) return memo[k];
    var url = ROOT + 'products/' + encodeURIComponent(it.h) + '?view=wlitem' + (it.v ? '&variant=' + it.v : '');
    function get(n) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      }).catch(function (e) { if (n > 0) return new Promise(function (ok) { setTimeout(ok, 600); }).then(function () { return get(n - 1); }); return null; });
    }
    memo[k] = get(2).then(function (h) { if (h === null) delete memo[k]; return h; });
    return memo[k];
  }
  function renderList(ul, empty, list, readonly) {
    var mine = (ul.__intWlRun = (ul.__intWlRun || 0) + 1);
    var wanted = list.filter(function (x) { return x.h; });
    if (!wanted.length) { ul.innerHTML = ''; ul.removeAttribute('aria-busy'); if (empty) empty.hidden = false; return Promise.resolve(); }
    if (empty) empty.hidden = true;
    ul.setAttribute('aria-busy', 'true');
    return Promise.all(wanted.map(itemHtml)).then(function (htmls) {
      if (ul.__intWlRun !== mine) return;
      var frag = document.createDocumentFragment(), n = 0;
      htmls.forEach(function (h) {
        if (!h) return;
        var t = document.createElement('template'); t.innerHTML = h.trim();
        var li = t.content.querySelector('li.int-wl-item'); if (!li) return;
        if (readonly) { var x = li.querySelector('[data-int-wl-remove]'); if (x) x.parentNode.removeChild(x); }
        frag.appendChild(li); n++;
      });
      ul.innerHTML = ''; ul.appendChild(frag); ul.removeAttribute('aria-busy');
      if (empty) empty.hidden = n > 0;
    });
  }

  /* ── remove and add to cart, in the drawer and on the page ── */
  function onClick(e) {
    var ab = e.target.closest && e.target.closest('[data-int-wl-atc] .int-wl-atc');
    if (ab) { e.preventDefault(); addToCart(ab); return; }
    var x = e.target.closest && e.target.closest('[data-int-wl-remove]');
    if (!x) return;
    e.preventDefault();
    var li = x.closest('.int-wl-item'); if (!li || !window.__intWl) return;
    li.classList.add('is-leaving');
    setTimeout(function () { window.__intWl.remove(li.getAttribute('data-p'), li.getAttribute('data-v')); }, 180);
  }
  /* 2026-11-03: a plain button and a direct cart/add.js call (no form), so no form handler on the page can hold it.
     The region guard's fetch wrapper still checks the id. The bag opens only once the piece is in it; a refusal is
     said under the button and the wishlist stays open. */
  function addToCart(btn) {
    var box = btn.closest('[data-int-wl-atc]'), vid = box && box.getAttribute('data-vid');
    if (!vid || btn.disabled) return;
    var msg = box.querySelector('.int-wl-atc-msg');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    btn.disabled = true; btn.classList.add('is-loading');
    var fd = new FormData(); fd.append('id', vid); fd.append('quantity', '1');
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (er) { throw new Error(er.description || er.message || 'add failed'); });
        return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r2) { return r2.json(); });
      })
      .then(function (cart) {
        if (drawer.isOpen()) drawer.close();
        if (typeof window.__intOpenCartDrawer === 'function') window.__intOpenCartDrawer({ pending: true });
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        var was = btn.textContent; btn.textContent = I.added || was;
        setTimeout(function () { btn.textContent = was; }, 2200);
        if (typeof window.__intOpenCartDrawer !== 'function') window.location.href = ROOT + 'cart';
      })
      .catch(function (er) {
        if (typeof window.__intSetCartPending === 'function') window.__intSetCartPending(false);
        if (msg) { msg.textContent = er.message; msg.hidden = false; }
      })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', onClick);

  /* ── share: a link that carries the pieces, opens read only on the wishlist page ── */
  var SHARE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="19" r="2.6"/><path d="M8.3 10.8l7.4-4.3M8.3 13.2l7.4 4.3"/></svg>';
  function shareUrl() {
    var list = window.__intWl ? window.__intWl.list().filter(function (x) { return x.h; }) : [];
    var base = String(I.page || (ROOT + 'pages/wishlist'));
    var u = new URL(base, location.origin);
    u.searchParams.set('items', list.map(function (x) { return x.h + ':' + x.v; }).join(','));
    return u.toString();
  }
  function toast(host, txt) {
    var t = el('div', 'int-wl-toast', txt); t.setAttribute('role', 'status');
    host.appendChild(t); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2200);
  }
  function share(host) {
    var url = shareUrl();
    if (navigator.share && matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: I.title || 'My Wishlist', url: url }).catch(function () {});
      return;
    }
    var done = function () { toast(host, I.copied || 'Link copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
    else window.prompt('', url);
  }
  function shareBtn(host) {
    var b = el('button', 'int-wl-share'); b.type = 'button';
    b.setAttribute('aria-label', I.share || 'Share your wishlist'); b.title = I.share || 'Share your wishlist';
    b.innerHTML = SHARE_SVG;
    b.addEventListener('click', function () { share(host); });
    return b;
  }

  /* ── the drawer ── */
  var drawer = (function () {
    var root = null, panel, ul, empty, band, shareB, lastFocus = null, open = false;
    function build() {
      root = el('div', 'int-wl-modal'); root.hidden = true;
      var back = el('div', 'int-wl-backdrop'); back.addEventListener('click', close);
      panel = el('div', 'int-wl-panel');
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', I.dialog || I.title || 'Wishlist'); panel.tabIndex = -1;
      var x = el('button', 'int-wl-close'); x.type = 'button'; x.setAttribute('aria-label', I.close || 'Close'); x.addEventListener('click', close);
      var scroll = el('div', 'int-wl-scroll');
      var top = el('div', 'int-wl-top');
      var logo = el('a', 'int-wl-logo'); logo.href = ROOT;
      var img = document.createElement('img'); img.src = LOGO; img.alt = 'Intention'; img.width = 140; img.height = 64;
      logo.appendChild(img); top.appendChild(logo);
      var head = el('div', 'int-wl-head');
      head.appendChild(el('h2', 'int-wl-title', I.title || 'My Wishlist'));
      shareB = shareBtn(panel); head.appendChild(shareB);
      band = el('div', 'int-wl-band');
      ul = el('ul', 'int-wl-grid'); ul.setAttribute('role', 'list');
      empty = el('p', 'int-wl-empty', I.empty || 'Tap the heart on any piece and it waits for you here.'); empty.hidden = true;
      scroll.appendChild(top); scroll.appendChild(head); scroll.appendChild(band); scroll.appendChild(ul); scroll.appendChild(empty);
      panel.appendChild(x); panel.appendChild(scroll);
      root.appendChild(back); root.appendChild(panel);
      document.body.appendChild(root);
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    function fill() {
      var list = window.__intWl ? window.__intWl.list() : [];
      renderBand(band);
      shareB.hidden = !list.some(function (x) { return x.h; });
      return renderList(ul, empty, list, false);
    }
    function doOpen() {
      if (open) return;
      open = true;
      css().then(function () {
        if (!open) return;
        if (!root) build();
        lastFocus = document.activeElement;
        fill();
        root.hidden = false;
        document.documentElement.classList.add('int-wl-lock');
        requestAnimationFrame(function () { root.classList.add('is-open'); panel.querySelector('.int-wl-close').focus({ preventScroll: true }); });
      });
    }
    function close() {
      if (!open) return;
      open = false;
      if (!root) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('int-wl-lock');
      setTimeout(function () { if (!open) root.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    document.addEventListener('int:wl', function (e) {
      if (!open || !root) return;
      if (e.detail && e.detail.type === 'remove') {
        var list = window.__intWl.list();
        Array.prototype.slice.call(ul.children).forEach(function (li) {
          var p = Number(li.getAttribute('data-p')), v = Number(li.getAttribute('data-v'));
          if (!list.some(function (x) { return x.p === p && x.v === v; })) li.parentNode.removeChild(li);
        });
        empty.hidden = ul.children.length > 0;
        shareB.hidden = !ul.children.length;
      } else fill();
    });
    return { open: doOpen, close: close, isOpen: function () { return open; } };
  })();
  if (window.__intWl && window.__intWl._setDrawer) window.__intWl._setDrawer(drawer);

  /* ── the wishlist page ── */
  function page() {
    var host = document.querySelector('[data-int-wl-page]');
    if (!host) return;
    var ul = host.querySelector('ul.int-wl-grid'), empty = host.querySelector('.int-wl-empty');
    var head = host.querySelector('.int-wl-head');
    var shared = null;
    try { shared = new URL(location.href).searchParams.get('items'); } catch (e) {}
    if (shared) {
      var list = shared.split(',').map(function (s) {
        var m = s.split(':'); return { h: decodeURIComponent(m[0] || ''), v: Number(m[1]) || 0, p: 0 };
      }).filter(function (x) { return /^[a-z0-9][a-z0-9-]*$/i.test(x.h); }).slice(0, 60);
      var t = host.querySelector('.int-wl-title'); if (t && I.sharedTitle) t.textContent = I.sharedTitle;
      renderList(ul, empty, list, true);
      return;
    }
    var sb = shareBtn(host); head.appendChild(sb);
    function draw() {
      var list = window.__intWl ? window.__intWl.list() : [];
      sb.hidden = !list.some(function (x) { return x.h; });
      renderList(ul, empty, list, false);
    }
    draw();
    document.addEventListener('int:wl', draw);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', page); else page();

  /* Cross-tab word changes only. */
  window.addEventListener('storage', function (e) { if (e.key === 'int_quiz_words' && drawer.isOpen()) drawer.open(); });
})();
